import { ASSET_CLASS_OPTIONS, PAY_METHOD_KIND_OPTIONS } from './coinPayTypeConstants';

export { ASSET_CLASS_OPTIONS, PAY_METHOD_KIND_OPTIONS };

const ASSET_CLASS_LABEL_MAP = Object.fromEntries(
  ASSET_CLASS_OPTIONS.map((item) => [item.value, item.label])
);

const PAY_METHOD_KIND_LABEL_MAP = Object.fromEntries(
  PAY_METHOD_KIND_OPTIONS.map((item) => [item.value, item.label])
);

/** 後備幣別（尚未建立 coin_pay_type 時） */
export const FALLBACK_CURRENCY_OPTIONS = [
  { value: 'USDT', label: 'USDT' },
  { value: 'USD', label: 'USD' },
  { value: 'CNY', label: 'CNY' },
  { value: 'TWD', label: 'TWD' },
  { value: 'TRY', label: 'TRY' },
];

export function formatAssetClassLabel(value) {
  return ASSET_CLASS_LABEL_MAP[value] || value || '—';
}

export function formatPayMethodKindLabel(value) {
  return PAY_METHOD_KIND_LABEL_MAP[value] || value || '—';
}

export function findCoinPayTypeById(coinPayTypes, id) {
  if (id == null || id === '') {
    return null;
  }
  return (coinPayTypes || []).find((item) => String(item.id) === String(id)) || null;
}

/** 由 coin_pay_type 去重產生幣別選項 */
export function buildCurrencyOptionsFromCoinPayTypes(coinPayTypes) {
  const seen = new Set();
  const options = [];
  for (const item of coinPayTypes || []) {
    const currency = item.currency?.trim();
    if (!currency || seen.has(currency)) {
      continue;
    }
    seen.add(currency);
    options.push({ value: currency, label: currency });
  }
  options.sort((a, b) => a.label.localeCompare(b.label));
  return options.length > 0 ? options : FALLBACK_CURRENCY_OPTIONS;
}

/** 鏈路下拉顯示：名稱 · 幣別 · 資產大類 */
export function formatCoinPayTypeSelectLabel(item) {
  if (!item) {
    return '';
  }
  const parts = [item.name, item.currency].filter(Boolean);
  if (item.protocol) {
    parts.push(`(${item.protocol})`);
  }
  if (item.assetClass) {
    parts.push(formatAssetClassLabel(item.assetClass));
  }
  return parts.join(' · ');
}

/** 依鏈路解析幣別（merchant_channel.currency_type 應與此一致） */
export function resolveCurrencyFromCoinPayType(coinPayTypes, coinPayTypeId) {
  const coinPayType = findCoinPayTypeById(coinPayTypes, coinPayTypeId);
  return coinPayType?.currency?.trim() || '';
}

/** 鏈路分類摘要（唯讀顯示用） */
export function describeCoinPayTypeClassification(coinPayType) {
  if (!coinPayType) {
    return {
      currency: '—',
      assetClassLabel: '—',
      payMethodKindLabel: '—',
    };
  }
  return {
    currency: coinPayType.currency || '—',
    assetClassLabel: formatAssetClassLabel(coinPayType.assetClass),
    payMethodKindLabel: formatPayMethodKindLabel(coinPayType.payMethodKind),
  };
}
